// extracted by mini-css-extract-plugin
export default {"accessDenied":"AccessDeniedPage_accessDenied__gj1Ju"};